<template>
  <div>
    <headline-container headline="Orders" :breadcrumbs="[{text: 'Orders'}]">
      <div class="btn-group">
        <button type="button" class="btn btn-white dropdown-toggle" data-toggle="dropdown">
          <i class="fa fa-cogs"></i> Order Functions <span class="caret"></span>
        </button>

        <ul class="dropdown-menu">
          <li>
            <router-link to="/orders/create">
              <i class="fa fa-plus"></i> Create Order
            </router-link>
          </li>

          <li v-if="hasPermission('admin')">
            <router-link to="/order-payments/create">
              <i class="fa fa-dollar-sign"></i> Invoice Orders
            </router-link>
          </li>

          <li v-if="hasPermission('admin')" role="separator" class="divider"></li>

          <li v-if="hasPermission('admin')">
            <a href="#download-orders-modal" data-toggle="modal">
              <i class="fa fa-cloud-download-alt"></i> Download Orders
            </a>
          </li>
        </ul>
      </div>
    </headline-container>

    <div v-if="!loading" class="container">
      <OrderList :users="users"/>
    </div>

    <DownloadOrdersModal/>
  </div>
</template>

<script>
import http from '@/http'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import Permissions from '@/mixins/Permissions'
import DownloadOrdersModal from '@/components/Modals/Orders/DownloadOrdersModal'
import OrderList from "../../../components/Relations/Orders/Panels/List.vue";

export default {
  components: {OrderList, DownloadOrdersModal, HeadlineContainer},

  mixins: [Permissions],

  data() {
    return {
      users: null,

      loading: true,
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/users', {page_size: 100}).then(response => {
        this.users = response.data.data

        this.loading = false
      })
    },
  }
}
</script>
